import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { loadPanicButtons } from '../../../redux/actions/userActions';
import sort from '../../../utilities/sort';

export function UnconnectedUserDashboardButtonsDisplay(props) {
  const { panicButtons = {}, userButtons } = props;

  useEffect(() => {
    props.dispatch(loadPanicButtons());
    // props.dispatch(loadAssociatedUserPanicButtons());
  }, []); //eslint-disable-line

  function buttonDisplay() {
    if (userButtons) {
      const buttonsData = userButtons.map((button) => {// eslint-disable-line
        if (panicButtons[button.button_id]) {
          return panicButtons[button.button_id];
        }
      });
      const sortedButtons = sort(buttonsData, 'title', 'az');
      const buttons = sortedButtons.map((button) => {// eslint-disable-line
        if (button) {
          return (
            <div className="" key={button.button_id} data-test="panic-button">
              {button.title}
            </div>
          );
        }
      });
      return buttons;
    } else {
      return '';
    }
  }
  return <div data-test="panic-buttons-list">{buttonDisplay()}</div>;
}

const mapStateToProps = (state, ownProps) => {
  return {
    userButtons: state.users.users[ownProps.userId].userbuttons,
    panicButtons: state.users.panicButtons,
  };
};
export default connect(mapStateToProps)(UnconnectedUserDashboardButtonsDisplay);
